import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../../createApiConfig';

export const dMDomainsXpathApi = createApi({
  reducerPath: 'dMDomainsXpathApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: [ 'DomainsXpath'],
  endpoints: (builder) => ({
    

    getDomainsXpath: builder.query({
      query: (params) => ({
        url: '/domains/domains-xpath/',
        method: 'GET',
        params,
      }),
      providesTags: ['DomainsXpath'],
    }),
    createDomainsXpath: builder.mutation({
      query: (body) => ({
        url: '/domains/domains-xpath/',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['DomainsXpath'],
    }),
    getDomainsXpathById: builder.query({
      query: ({ id, ...params }) => ({
        url: `/domains/domains-xpath/${id}`,
        method: 'GET',
        params,
      }),
      providesTags: (result, error, { id }) => [{ type: 'DomainsXpath', id }],
    }),
    updateDomainsXpathById: builder.mutation({
      query: ({ id, body }) => ({
        url: `/domains/domains-xpath/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['DomainsXpath'],
    }),
    deleteDomainsXpathById: builder.mutation({
      query: (id) => ({
        url: `/domains/domains-xpath/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['DomainsXpath'],
    }),

   
  }),
});

export const {
  useGetDomainsXpathQuery,
  useCreateDomainsXpathMutation,
  useUpdateDomainsXpathByIdMutation,
  useDeleteDomainsXpathByIdMutation,
} = dMDomainsXpathApi;
